import { IconProps } from '.';

export const ViewportIcon = ({ className = '', color = 'black' }: IconProps) => {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.25 2.25H3.75C2.50736 2.25 1.5 3.25736 1.5 4.5L16.5 4.5C16.5 3.25736 15.4926 2.25 14.25 2.25ZM0 4.5V6V13.5C0 15.5711 1.67893 17.25 3.75 17.25H14.25C16.3211 17.25 18 15.5711 18 13.5V6V4.5C18 2.42893 16.3211 0.75 14.25 0.75H3.75C1.67893 0.75 0 2.42893 0 4.5ZM16.5 13.5V6H6L6 15.75H14.25C15.4926 15.75 16.5 14.7426 16.5 13.5ZM4.5 15.75H3.75C2.50736 15.75 1.5 14.7426 1.5 13.5V6H4.5L4.5 15.75Z'
        fill={color}
      />
    </svg>
  );
};
